import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, TitleStrategy, withPreloading } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { BrowserPlatformLocation, PlatformLocation } from '@angular/common';
import { LucideAngularModule, icons } from 'lucide-angular';
import { CookieService } from 'ngx-cookie-service';
import { provideTranslateService } from '@ngx-translate/core';

import { routes } from './app.routes';
import { NetworkAwarePreloadingStrategy } from './core/preloading/network-aware-preloading.strategy';
import { AppTitleStrategy } from './core/title/title.strategy';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { LanguageService } from './core/services/language.service';
import { GlobalErrorHandler } from './core/services/global-error-handler.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withPreloading(NetworkAwarePreloadingStrategy)),
    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor, errorInterceptor]),
    ),
    CookieService,
    { provide: PlatformLocation, useClass: BrowserPlatformLocation },
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    importProvidersFrom(LucideAngularModule.pick(icons)),
    ...provideTranslateService({
      fallbackLang: 'en',
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: (lang: LanguageService) => () => lang.init(),
      deps: [LanguageService],
      multi: true,
    },
  ],
};
